module.exports = __webpack_public_path__ + "static/media/pool.b34caf27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/objects/characteristics/pool.svg
// module id = 866
// module chunks = 0